import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import MerchantsLayout from '../../layout/layouts/MerchantsLayout';
import { AccountsList } from '../../Pages/Accounts/AccountsList';
import {
  MyAccountAuthenticationPage,
  MyAccountChangePasswordPage,
  MyAccountDetailsPage,
} from '../../Pages/Accounts/MyAccount';
import { resources } from '../../resources/resources';

export const AccountsRoutes = () => {
  const { t: translate } = useTranslation();
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WithTabTitle title={translate(resources.menu.members)}>
            <MerchantsLayout>
              <AccountsList />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/my-account/details"
        element={
          <WithTabTitle title={translate(resources.userMenu.account)}>
            <MerchantsLayout>
              <MyAccountDetailsPage />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/my-account/change-password"
        element={
          <WithTabTitle title={translate(resources.userMenu.changePassword)}>
            <MerchantsLayout>
              <MyAccountChangePasswordPage />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/my-account/authentication"
        element={
          <WithTabTitle title={translate(resources.userMenu.communication)}>
            <MerchantsLayout>
              <MyAccountAuthenticationPage />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
    </Routes>
  );
};
